"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var layout_utils_1 = require("../utils/layout-utils");
var form_converters_pool_1 = require("./form-converters.pool");
var page_converters_pool_1 = require("./page-converters.pool");
var ModelConverterService = /** @class */ (function () {
    function ModelConverterService(moduleRegistryServiceForm, kbService) {
        this.moduleRegistryServiceForm = moduleRegistryServiceForm;
        this.kbService = kbService;
    }
    ModelConverterService.prototype.fromDomainToFormDesignerLayout = function (layout) {
        return form_converters_pool_1.FormConvertersPool.layoutFromDomain.apply(layout);
    };
    ModelConverterService.prototype.fromDomainToPageDesignerLayout = function (layout) {
        return page_converters_pool_1.PageConvertersPool.layoutFromDomain.apply(layout);
    };
    ModelConverterService.prototype.fromDesignerLayoutToFormDomain = function (designerLayout, category, formName, parentCategory, formType) {
        var contentGrid = form_converters_pool_1.FormConvertersPool.contentFromLayoutCard.apply(designerLayout.content);
        var control;
        var subwayMap;
        if (designerLayout.header) {
            control = new idm_dynamic_layout_interpreter_1.ControlModel(designerLayout.header.id, designerLayout.header.fields, designerLayout.header.meta.selector, designerLayout.header.bindings, designerLayout.header.actions, idm_dynamic_layout_interpreter_1.ControlPropertiesModel.fromJS(designerLayout.header.id, designerLayout.header.state), designerLayout.header.meta, designerLayout.header.isConfigurable);
        }
        if (designerLayout.subwayMap) {
            subwayMap = new idm_dynamic_layout_interpreter_1.ControlModel(designerLayout.subwayMap.id, designerLayout.subwayMap.fields, designerLayout.subwayMap.meta.selector, designerLayout.subwayMap.bindings, designerLayout.subwayMap.actions, idm_dynamic_layout_interpreter_1.ControlPropertiesModel.fromJS(designerLayout.subwayMap.id, designerLayout.subwayMap.state), designerLayout.subwayMap.meta, designerLayout.subwayMap.isConfigurable);
        }
        var fixedModuleKeys = this.findUsedModules(designerLayout);
        switch (designerLayout.formEntityType) {
            case idm_dynamic_layout_interpreter_1.FormEntityType.MAIN_FORM:
                return of_1.of(new idm_dynamic_layout_interpreter_1.FormLayoutModel(category, formName, contentGrid, control, undefined, undefined, fixedModuleKeys, subwayMap));
            case idm_dynamic_layout_interpreter_1.FormEntityType.SUB_FORM:
                return this.makeSubFormFooter(category, parentCategory, fixedModuleKeys, formType).pipe(operators_1.map(function (footer) {
                    return new idm_dynamic_layout_interpreter_1.FormLayoutModel(category, formName, contentGrid, control, footer, undefined, fixedModuleKeys, subwayMap);
                }));
            case idm_dynamic_layout_interpreter_1.FormEntityType.WORKFLOW_FORM:
                return of_1.of(new idm_dynamic_layout_interpreter_1.FormLayoutModel(category, formName, contentGrid, control, undefined, undefined, fixedModuleKeys, subwayMap));
        }
    };
    ModelConverterService.prototype.fromDesignerLayoutToPageDomain = function (designerLayout, pageName) {
        var contentGrid = page_converters_pool_1.PageConvertersPool.contentFromLayout.apply(designerLayout);
        return new idm_dynamic_layout_interpreter_1.PageLayoutModel(pageName, contentGrid);
    };
    ModelConverterService.prototype.findUsedModules = function (designerLayout) {
        var _this = this;
        var result = immutable_1.Set().asMutable();
        if (!lodash_1.isNil(designerLayout) &&
            !lodash_1.isNil(designerLayout.content) &&
            !lodash_1.isNil(designerLayout.content.layoutRows)) {
            if (!designerLayout.content.isWithTabs()) {
                designerLayout.content.layoutRows.forEach(function (row) {
                    return row.cards.forEach(function (card) {
                        return _this.addCardControllerModuleKeys(result, card);
                    });
                });
            }
            else {
                for (var _i = 0, _a = designerLayout.content.tabs; _i < _a.length; _i++) {
                    var tabModle = _a[_i];
                    tabModle.tabLayout.layoutRows.forEach(function (row) {
                        return row.cards.forEach(function (card) {
                            return _this.addCardControllerModuleKeys(result, card);
                        });
                    });
                }
            }
            if (!lodash_1.isNil(designerLayout.header)) {
                result.add(designerLayout.header.meta.moduleKey);
            }
            if (!lodash_1.isNil(designerLayout.subwayMap)) {
                result.add(designerLayout.subwayMap.meta.moduleKey);
            }
        }
        return result.toArray();
    };
    ModelConverterService.prototype.addCardControllerModuleKeys = function (keySet, card) {
        if (!lodash_1.isNil(card.formCardRows)) {
            for (var _i = 0, _a = card.formCardRows; _i < _a.length; _i++) {
                var row = _a[_i];
                if (!lodash_1.isNil(row.cells)) {
                    for (var _b = 0, _c = row.cells; _b < _c.length; _b++) {
                        var cell = _c[_b];
                        if (cell.isController()) {
                            keySet.add(cell.controller.meta.moduleKey);
                        }
                        if (cell.isCard()) {
                            this.addCardControllerModuleKeys(keySet, cell.card);
                        }
                    }
                }
            }
        }
    };
    ModelConverterService.prototype.makeSubFormFooter = function (category, parentCategory, fixedModuleKeys, formType) {
        var _this = this;
        var isEditForm = formType === idm_dynamic_layout_interpreter_1.FormType.EDIT;
        return this.kbService.getMetaFields(parentCategory).pipe(operators_1.mergeMap(function (fields) {
            var subEntityField = fields.find(function (field) {
                return (field.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY &&
                    field.getCompoundCategorySystemName() === category);
            });
            return _this.moduleRegistryServiceForm
                .findControl('sis-button')
                .pipe(operators_1.map(function (meta) {
                var _a, _b, _c;
                var controlId = layout_utils_1.LayoutUtils.uniqueId();
                var editButton = new idm_dynamic_layout_interpreter_1.ControlModel(controlId, undefined, meta.selector, {
                    onClick: "actions.editSubEntity(form, item, '" + subEntityField.getSystemName() + "', true)",
                }, {}, idm_dynamic_layout_interpreter_1.ControlPropertiesModel.fromJS(controlId, (_a = {
                        isShown: true,
                        close: true,
                        color: 'primary',
                        button_msg: 'de_done'
                    },
                    _a[idm_dynamic_layout_interpreter_1.ControlPropertiesModel.GENERATED_ID_SUFFIX_KEY] = subEntityField.getSystemName() + "-Edit",
                    _a)), meta);
                controlId = layout_utils_1.LayoutUtils.uniqueId();
                var addButton = new idm_dynamic_layout_interpreter_1.ControlModel(controlId, undefined, meta.selector, {
                    onClick: "actions.addSubEntity(form, item, '" + subEntityField.getSystemName() + "', true)",
                }, {}, idm_dynamic_layout_interpreter_1.ControlPropertiesModel.fromJS(controlId, (_b = {
                        isShown: true,
                        close: true,
                        color: 'primary',
                        button_msg: 'de_add'
                    },
                    _b[idm_dynamic_layout_interpreter_1.ControlPropertiesModel.GENERATED_ID_SUFFIX_KEY] = subEntityField.getSystemName() + "-Add",
                    _b)), meta);
                controlId = layout_utils_1.LayoutUtils.uniqueId();
                var cancelButton = new idm_dynamic_layout_interpreter_1.ControlModel(controlId, undefined, meta.selector, {
                    onClick: isEditForm
                        ? "actions.onCancelPopup(form, '" + subEntityField.getCompoundCategorySystemName() + "', '" + subEntityField.getSystemName() + "')"
                        : 'form.activePopup.close()',
                }, undefined, idm_dynamic_layout_interpreter_1.ControlPropertiesModel.fromJS(controlId, (_c = {
                        isShown: true,
                        close: true,
                        button_msg: isEditForm
                            ? 'de_cancel'
                            : 'de_close'
                    },
                    _c[idm_dynamic_layout_interpreter_1.ControlPropertiesModel.GENERATED_ID_SUFFIX_KEY] = subEntityField.getSystemName() + "-Cancel",
                    _c)), meta);
                var editCellPropertiesModel = new idm_dynamic_layout_interpreter_1.CellPropertiesModel(editButton.id, 'transparent', {
                    xs: 6,
                    s: 6,
                    m: 6,
                }, undefined, immutable_1.Map({}), new idm_dynamic_layout_interpreter_1.VisibilityCondition(function (cont) {
                    return isEditForm && cont.popupEditMode;
                }, {
                    $and: [
                        { isEditForm: true },
                        { popupEditMode: true },
                    ],
                }));
                var editCell = new idm_dynamic_layout_interpreter_1.CellModel(editButton.id, editCellPropertiesModel, undefined, undefined, editButton);
                var addCellPropertiesModel = new idm_dynamic_layout_interpreter_1.CellPropertiesModel(addButton.id, 'transparent', {
                    xs: 6,
                    s: 6,
                    m: 6,
                }, undefined, immutable_1.Map(), new idm_dynamic_layout_interpreter_1.VisibilityCondition(function (cont) {
                    return isEditForm && !cont.popupEditMode;
                }, {
                    $and: [
                        { isEditForm: true },
                        { popupEditMode: false },
                    ],
                }));
                var addCell = new idm_dynamic_layout_interpreter_1.CellModel(addButton.id, addCellPropertiesModel, undefined, undefined, addButton);
                var cancelCell = new idm_dynamic_layout_interpreter_1.CellModel(cancelButton.id, idm_dynamic_layout_interpreter_1.CellPropertiesModel.createEmpty(cancelButton.id), undefined, undefined, cancelButton);
                if (!lodash_1.includes(fixedModuleKeys, meta.moduleKey)) {
                    fixedModuleKeys.push(meta.moduleKey);
                }
                var rowId = layout_utils_1.LayoutUtils.uniqueId();
                var row = new idm_dynamic_layout_interpreter_1.RowModel(rowId, [cancelCell, editCell, addCell], idm_dynamic_layout_interpreter_1.RowPropertiesModel.createEmpty(rowId));
                var gridId = layout_utils_1.LayoutUtils.uniqueId();
                return new idm_dynamic_layout_interpreter_1.GridModel(gridId, [row], idm_dynamic_layout_interpreter_1.GridType.FLAT, idm_dynamic_layout_interpreter_1.GridPropertiesModel.createEmpty(gridId));
            }));
        }));
    };
    ModelConverterService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(idm_dynamic_layout_interpreter_1.formModuleRegistryKey)),
        __metadata("design:paramtypes", [idm_dynamic_layout_interpreter_1.ModuleRegistryService,
            idm_kb_service_client_js_1.KbService])
    ], ModelConverterService);
    return ModelConverterService;
}());
exports.ModelConverterService = ModelConverterService;
//# sourceMappingURL=model-converter.service.js.map